import * as Common from '@/tenant/common';

export enum ProjectItemStatus
{
  Active = 1, // アクティブ
  Closed = 2, // 終了
}

export class ProjectItem extends Common.StateObject{
  constructor(){
    super('ProjectItem');
    this.binders.segment = new Common.ModelBinder(Common.Segment);
    this.binders.counterpart = new Common.ModelBinder(Common.Counterpart);
    this.binders.account = new Common.ModelBinder(Common.Account);
    this.binders.paymentBalance = new Common.ModelBinder(Common.TransferBalance);
    this.workflowCode="projectItem";
    this.state = ProjectItemStatus.Active;
    this.workflowStateId = ProjectItemStatus.Active;
  }
  public projectItemNo: string = null;
  public name : string = null;    
  public startDate: Date = null;
  public counterpart : Common.Counterpart = null;
  public get counterprtName() : string{ return this.counterpart ? this.counterpart.name : '';}
  public get actionTooltip() {
    if (this.state == ProjectItemStatus.Active)　return '案件を完了する場合は【完了】をクリックします。';      
    else return '案件を再開する場合は【再開】をクリックします。';
  }    
  public copy():any {
    const temp = super.copy() as ProjectItem;
    temp.projectItemNo = null;
    return temp;
  }  
}

export class ProjectItemQuery extends Common.LoadQuery {
  constructor(){
    super('ProjectItemQuery', ProjectItem);
    this.sort = 'projectItemNo';
  }
  public projectItemNo:string = null;
  public name: string = null;
  public counterpart: Common.Counterpart = null;  
  public startDateFrom: Date = null;  
  public startDateTo: Date = null;    
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: ProjectItemStatus = null;
  public holder: string = "";  
}
export class ProjectItemMasterQuery extends Common.LoadQuery {
  constructor(){
    super('ProjectItemMasterQuery', ProjectItem);
  }
  public showExcludeItem :boolean = false;
}